import { LoadingOutlined } from "@ant-design/icons";
import { Empty } from "antd";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Search, Product } from "../../components";
import { getDataTrouser } from "../../config/Redux/action";
import { ActionProduct } from "../../config/Redux/actionTypes";

const Trouser = () => {
    const dispatch = useDispatch();
    const product = useSelector((state) => state.product)
    const [trousers, setTrousers] = useState([]);
    let dataAosIcrement = 500;

    useEffect(() => {
      const getData = async () => {
        const res = await dispatch(getDataTrouser());
        setTrousers(res);
      };
      getData();
    }, [dispatch]);

    const totalTrouser = trousers.filter((trouser) => trouser.data.publish === 'published');

    const handleSearch = async (e) => {
        e.preventDefault();
        const data = await dispatch(getDataTrouser());

        const search = data.filter((trouser) => {
            return Object.values(trouser.data.name).join('').toLowerCase().includes(product.search.toLowerCase());
        })
        dispatch({type: ActionProduct.SEARCH, value: ''})
        setTrousers(search);
    }

  return (
    <div id='product-user'>
      <main>
        <section className='search'>
          <Search value={product.search} search={handleSearch} />
        </section>
        <section className='trouser'>
          <h1 data-aos='fade-right'>Produk Celana</h1>
          {product.isLoading ? (
            <LoadingOutlined className='loadingProduct' />
          ) : (
            <div
              className={totalTrouser.length > 0 ? 'product-content' : 'empty'}
            >
              {totalTrouser.length > 0 ? (
                trousers
                  .filter((trouser) => trouser.data.publish === 'published')
                  .map((trouser) => {
                    return (
                      <Product
                        delay={(dataAosIcrement += 200)}
                        key={trouser.id}
                        link={`detail/${trouser.id}`}
                        image={trouser.data.image_url}
                        name={trouser.data.name}
                        normalPrice={trouser.data.price}
                        discount={trouser.data.promoPrice}
                      />
                    );
                  })
              ) : (
                <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
              )}
            </div>
          )}
        </section>
      </main>
    </div>
  );
}

export default Trouser